<div [class]="showSpinner ? 'visible spinner center' : 'hidden spinner center'" [innerHTML]="template"></div>

<h4 [style.zIndex]="zIndex" [class]="showSpinner ? 'visible loading-text' : 'hidden loading-text'">
	{{ loadingText }}
</h4>

<div class="sr-only" role="status" aria-live="polite" aria-atomic="true">
	{{ showSpinner ? loadingText : '' }}
</div>
